export const getHomeRoute = () => '/';
export const getNewsRoute = () => `/news`;
export const HouseRoute = () => `/houses`;
export const getNewsItemRoute = (newsItemId = ':newsItemId?') => `/news/${newsItemId}`;
export const HouseItemRoute = (houseId = ':houseId?') => `/houses/${houseId}`;
export const getPhotosRoute = () => '/photos';
export const getPhotosAlbumRoute = (albumId = ':albumId?') => `/photos/${albumId}`;
export const getScandinavianRoute = () => '/scandinavian';
export const getDesigningRoute = () => '/designing';
export const getConsultingRoute = () => '/consulting';